<script>
    import {createEventDispatcher} from 'svelte';
    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Boton from "../../UI/Boton.svelte";
    import Modal from "../../UI/Modal.svelte";
    import Icono from "../../UI/Icono.svelte";

    import {onMount} from 'svelte';
    import store from '../../../Stores/grupo-store';
    import storeGrupos from '../../../Stores/grupos-store';
    import BuscadorDeGrupos from "../../UI/BuscadorDeGrupos.svelte";
    import Loading from "../../UI/Loading.svelte";

    const dispatch = createEventDispatcher();

    let grupos;
    onMount(() => storeGrupos.cargar());
    $: grupos = $storeGrupos.listado.filter(x => x.id !== grupo.id);

    let grupo;
    $: grupo = $store.grupo;

    const cancelaRecuperacion = () => {
        seleccionandoGrupo = false;
        grupoOrigen = false;
        recuperandoEmpresa = false;
    };

    let recuperandoEmpresa = false;
    const recuperaDeEmpresa = () => {
        dispatch('restaurar-de-empresa');
        recuperandoEmpresa = false;
    };
</script>

<style>
    .advertencia {
        color: var(--acentos);
    }

    .grupos {
        display: flex;
        flex-direction: column;
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>Restauración de calendario</Subtitulo>
    </div>

    <p>
        <Boton on:click={() => recuperandoEmpresa = true}>Eliminar personalización</Boton>
    </p>
</Caja>

{#if recuperandoEmpresa }
    <Modal title="Restauración de calendario" estrecho on:cancel={cancelaRecuperacion}>
        <p>Se va a restaurar el calendario de la <strong>empresa</strong> para el grupo
            <em>{grupo.nombre}.</em></p>
        <p class="advertencia">Esta acción no se puede deshacer</p>

        <div slot="footer">
            <Boton on:click={recuperaDeEmpresa} tipo="peligro">
                <Icono margen>check</Icono>
                Restaurar
            </Boton>

            <Boton on:click={cancelaRecuperacion} tipo="neutral">
                <Icono margen>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}